<template>
  <!--
      作者：gmshop
      时间：2020-06-25
      描述：设置-配送设置
    -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="基础设置" name="first" v-if="show_Setting == true"></el-tab-pane>
      <el-tab-pane label="配送" name="second" v-if="show_Distribution == true"></el-tab-pane>
      <el-tab-pane label="自提" name="third" v-if="show_Extract == true"></el-tab-pane>
      <el-tab-pane label="自提店员" name="fourth" v-if="show_Clerk == true"></el-tab-pane>
    </el-tabs>
    <Setting v-if="activeName == 'first' && show_Setting == true"></Setting>
    <Distribution v-if="activeName == 'second' && show_Distribution == true"></Distribution>
    <Extract v-if="activeName == 'third' && show_Extract == true"></Extract>
    <clerk v-if="activeName == 'fourth' && show_Clerk == true"></clerk>
  </div>
</template>
<script>
import Setting from './dialog/setting';
import Distribution from './dialog/distribution';
import Extract from './dialog/extract';
import Clerk from './dialog/clerk/index';
export default {
  components: {
    /*基础设置*/
    Setting,
    /*配送*/
    Distribution,
    /*自提*/
    Extract,
    /*自提店员*/
    Clerk,
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      activeName: 'first',
      /*权限检测*/
      show_Setting: false,
      show_Distribution: false,
      show_Extract: false,
      show_Clerk: false,
    };
  },
  created() {
    /*权限检测*/
    if(this.$filter.isAuth('/setting/distribution/dialog/setting'))  this.show_Setting = true;
    if(this.$filter.isAuth('/setting/distribution/dialog/distribution'))  this.show_Distribution = true;
    if(this.$filter.isAuth('/setting/distribution/dialog/extract'))  this.show_Extract = true;
    if(this.$filter.isAuth('/setting/distribution/dialog/clerk/index'))  this.show_Clerk = true;

    /*默认值*/
    if(this.show_Setting == true){
      this.activeName = 'first';
    }else if(this.show_Distribution == true){
      this.activeName = 'second';
    }else if(this.show_Extract == true){
      this.activeName = 'third';
    }else if(this.show_Clerk == true){
      this.activeName = 'fourth';
    }

    let active_name = localStorage.getItem('activeName')
    if(active_name){
      this.activeName = active_name
      localStorage.clear()
    }
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/setting/distribution/index.vue